/* eslint-disable react/no-array-index-key */

import classNames from 'classnames';

import type { ProductSustainabilityScore } from '../../../common/models/props/itemTeaserProps';

import styles from './SustainabilityLights.module.scss';
import { getLights, getSustainabilityA11yLabelFromLights } from './SustainabilityLights.utils';

interface LightsProps {
    id?: string;
    productScores: ProductSustainabilityScore[];
    'aria-hidden'?: boolean;
}

const SustainabilityLights = (props: LightsProps) => {
    const lights = getLights(props.productScores);
    const risksLabel = getSustainabilityA11yLabelFromLights(lights);

    return (
        <div
            aria-hidden={props['aria-hidden']}
            id={props.id}
            className={classNames(styles.Lights)}
            aria-label={risksLabel}
        >
            {lights.map((item) => (
                <img key={item.id} className={styles.Light} alt="" src={item.url} />
            ))}
        </div>
    );
};

export default SustainabilityLights;
